import axios from 'axios';
import utils from './utils';
import { filterMenuKeys } from '@js/config/menu-config';

let inflight = null;

/**
 * 桌面端（HEYADMIN_DESKTOP）自动以 admin 建会话。
 * 非桌面端接口返回 403，返回 false，仍走登录页。
 */
export function ensureDesktopAuth() {
  if (utils.getLocal('token')) {
    return Promise.resolve(true);
  }
  if (inflight) {
    return inflight;
  }
  inflight = axios
    .request({
      url: '/api/desktop/auto-login',
      method: 'POST',
      data: {},
      headers: { author: utils.getAuthor() || 'heyui' },
      validateStatus: () => true
    })
    .then((response) => {
      const data = response.data || {};
      if (response.status !== 200 || data.status !== 200 || !data.body || !data.body.value) {
        return false;
      }
      const token = data.body.value;
      utils.saveLocal('token', token);
      utils.saveLocal('username', data.body.username || 'admin');
      utils.saveLocal('DESKTOP_SKIP_LOGIN', '1');
      return axios
        .request({
          url: '/api/account/menus',
          method: 'GET',
          headers: {
            author: utils.getAuthor() || 'heyui',
            Authorization: token
          },
          validateStatus: () => true
        })
        .then((menuResp) => {
          const menuData = menuResp.data || {};
          if (menuResp.status === 200 && menuData.status === 200 && menuData.body && Array.isArray(menuData.body.menus)) {
            utils.saveLocal('SYS_USER_MENUS', filterMenuKeys(menuData.body.menus));
          }
          return true;
        })
        .catch(() => true);
    })
    .catch(() => false)
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

export function isDesktopSkipLogin() {
  return utils.getLocal('DESKTOP_SKIP_LOGIN') === '1';
}
